"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Retrieves all props included in `from` array
 *
 * @param source (Props) - source object
 * @param from (string[]) - array of keys needed to retrieve from `source`
 *
 * @return (Partial<Props>) - object with keys contained in `from` array
 */
function all(source, from) {
    if (!source) {
        return {};
    }
    return from.reduce((acc, prop) => {
        return { ...acc, [prop]: source[prop] };
    }, {});
}
exports.all = all;
/**
 * Retrieves all props included in `from` array, rest props includes in under the `rest` key
 */
function allWithRest(source, from) {
    if (!source) {
        return { rest: {} };
    }
    return Object.keys(source).reduce((acc, prop) => {
        const { rest, ...allOf } = acc;
        if (from.includes(prop)) {
            return { ...allOf, [prop]: source[prop], rest };
        }
        return { ...allOf, rest: { ...rest, [prop]: source[prop] } };
    }, {});
}
exports.allWithRest = allWithRest;
/**
 * Returns all styles with prefix
 *
 * @param {StyleType} source - Eva Styles
 * @param {string} key - prefix
 *
 * @return {StyleType} - all styles with prefix
 */
function allWithPrefix(source, key) {
    return Object.keys(source)
        .filter((styleName) => styleName.includes(key))
        .reduce((obj, styleKey) => {
        return {
            ...obj,
            [styleKey]: source[styleKey],
        };
    }, {});
}
exports.allWithPrefix = allWithPrefix;
//# sourceMappingURL=props.service.js.map